import {Injectable} from '@angular/core';
import {NeqDialogErrorComponent} from '@sharedcommon/components/dialog/dialog-error.component';
import {NeqErrorModel} from '@sharedcommon/model/neq-error.model';
import {FunctionUtils} from '@sharedcommon/util/functions.util';
import {NeqConfirmationPopinComponent} from '@sharedcommon/components/confirmation-popin/confirmation-popin.component';
import { NeqRgpdPopinComponent } from '@sharedcommon/components/rgpd-popin/rgpd-popin.component';
import {MatDialog} from '@angular/material/dialog';
import {NeqErrorPopinComponent} from '@sharedcommon/components/error-popin/error-popin.component';
import { NeqInformationPopinComponent } from '@sharedcommon/components/information-popin/information-popin.component';
import { NeqEditionPopinComponent } from '@sharedcommon/components/edition-popin/edition-popin.component';

@Injectable()
export class NeqDialogService {

  constructor(
    private readonly dialog: MatDialog
  ) {
  }

  showConfirmation(message: string) {
    return this.dialog.open(NeqConfirmationPopinComponent, {
      data: {
        message: message
      }
    });
  }

  showInformation(messageKey: string, params?: any) {
    return this.dialog.open(NeqInformationPopinComponent, {
      data: {
        message: messageKey,
        params: params
      }
    })
  }

  showRgpd(message: string) {
    return this.dialog.open(NeqRgpdPopinComponent, {
      data: {
        message: message
      }
    });
  }

  showErrorSimple(message: string, errorDetail: string = '') {
    return this.dialog.open(NeqErrorPopinComponent, {
      data: {
        message: message,
        errorDetails: errorDetail.split(',')
      }
    });
  }

  showErrorSimpleOneMessage(message: string) {
    return this.dialog.open(NeqErrorPopinComponent, {
      data: {
        message: message
      }
    });
  }

  showErrorDetail(err: any, message: string) {
    let neqError: NeqErrorModel;
    let otherError: any;

    if (FunctionUtils.isDefined(err.error)) {
      try {
        neqError = err.error;
      } catch (e) {
        console.error('unknown error : ');
        console.dir(e);
        otherError = err;
      }
    } else {
      try {
        neqError = err;
      } catch (e) {
        console.error('unknown error : ');
        console.dir(e);
        otherError = err;
      }
    }

    if (!err.uuid) {
      neqError = undefined;
      otherError = err;
    }

    return this.dialog.open(NeqDialogErrorComponent, {
      data: {message: message, neqError: neqError, otherError: otherError}
    });
  }

  showEditionPopin(columnField: string, type: string, options: any = null) {
    return this.dialog.open(NeqEditionPopinComponent, {
      data: { columnField: columnField, type: type, options: options}
    });
  }
}
